import styled from "styled-components";
import { useRef } from "react";
import FeatureRowItem from "./FeatureRowItem";
import { useTranslation } from "react-i18next";
import { LuBicepsFlexed, LuDumbbell } from "react-icons/lu";
import { MdEventAvailable } from "react-icons/md";
import { RiHeartPulseLine } from "react-icons/ri";

const Container = styled.div`
  display: flex;
  flex-direction: row;
  /* gap: 100px; */
  justify-content: space-between;
  margin-top: 100px;
  width: 90vw;

  border: 1px solid var(--elementDim);

  border-radius: 30px;

  padding: 20px 7vw;

  @media (max-width: 900px) {
    display: flex;
    flex-direction: column;
    gap: 23px;
  }
`;

export default function FeatureRow({ containerRef }) {
  const targetRef = useRef(null);
  const { t } = useTranslation();

  return (
    <Container>
      <FeatureRowItem
        icon={<LuBicepsFlexed />}
        // image="biceps.png"
        title={t("eliteTrainer")}
      />

      <FeatureRowItem
        icon={<RiHeartPulseLine />}
        // image="heart.png"
        title={t("regularHealthCheckups")}
      />

      <FeatureRowItem
        icon={<LuDumbbell />}
        // image="dumbbell.png"
        title={t("cuttingEdgeEquipments")}
      />

      <FeatureRowItem
        icon={<MdEventAvailable />}
        // image="events.png"
        title={t("exclusiveEvents")}
      />
    </Container>
  );
}
